import { createApiSlice } from "@common";
import { CRUD_CONTACT_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addContactStatus",
    method: "post",
    url: CRUD_CONTACT_STATUS,
    stateKey: "message",
  },

  {
    name: "getContactStatus",
    method: "get",
    url: CRUD_CONTACT_STATUS,
    stateKey: "data",
  },

  {
    name: "updateContactStatus",
    method: "put",
    url: CRUD_CONTACT_STATUS,
    stateKey: "message",
  },

  {
    name: "deleteContactStatus",
    method: "delete",
    url: CRUD_CONTACT_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "contactStatus", apiConfig, customReducers);
const contactStatusSlice = slice;

export default contactStatusSlice.reducer;

export const {
  addContactStatus,
  getContactStatus,
  updateContactStatus,
  deleteContactStatus,
} = thunks;

export const { rowSelect } = actions;
